import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MakePaymentRoutingModule } from './make-payment-routing.module';
import { PayCreditDebitComponent } from './pay-credit-debit/pay-credit-debit.component';
import { MakePaymentService } from './make-payment.service';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { PipeModule } from '../../shared/pipe/pipe.module';
import { ServiceWillNotStartDialog } from './make-payment/make-payment.component';
import { CardList } from './pay-credit-debit/pay-credit-debit.component';
import { ManageCardsService } from '../manage-cards/manage-cards.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatTableModule,
  MatToolbarModule,
  MatProgressSpinnerModule
} from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';
import {AuthModule} from '../../auth/auth.module';
import {CustomerEnrollModule} from '../../customer-enroll/customer-enroll.module';
import {ViewPaymentMethodsComponent} from '../paymentus/view-payment-methods/view-payment-methods.component';
import {PaymentusModule} from '../paymentus/paymentus.module';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
    imports: [
        CommonModule,
        MakePaymentRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule.forRoot(),
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatTableModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        TextMaskModule,
        AuthModule,
        CustomerEnrollModule,
        PaymentusModule
    ],
  providers: [MakePaymentService, ManageCardsService],
  bootstrap: [CardList, ViewPaymentMethodsComponent, ServiceWillNotStartDialog],
  declarations: [
    PayCreditDebitComponent,
    MakePaymentComponent,
    CardList,
    ServiceWillNotStartDialog
  ]
})
export class MakePaymentModule { }



// WEBPACK FOOTER //
// ./src/app/payment/make-payment/make-payment.module.ts